import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export abstract class BaseModal {
  constructor(protected modal: NgbActiveModal) {}
  close() {
    this.modal.close();
  }
}
